export default __webpack_public_path__ + "static/media/pencil.3fea5b0b.svg";